import {
  generateLockId
} from "./chunk-U6DW2ZKJ.mjs";
import {
  defaultMutexLockTimeout,
  defaultOldEventTimeLimit
} from "./chunk-ADSPBXJF.mjs";

// src/batching/lock-events/lock-events.ts
async function lockEvents() {
  if (typeof window !== "undefined" && window.yvaDatastore) {
    const now = Date.now();
    const expiration = window.yvaDatastore.config.mutexLockTimeout ?? defaultMutexLockTimeout;
    const limit = window.yvaDatastore.config.oldEventTimeLimit ?? defaultOldEventTimeLimit;
    const lockVersion = generateLockId({ expiration, lockTime: now });
    const events = [];
    window.yvaDatastore.events.forEach((event) => {
      if (event.status === "ready" && (event.lockId === null || parseInt(event.lockId.split("+")[1], 10) < now) && event.data.created > now - limit) {
        event.lockId = lockVersion;
        events.push(event);
      }
    });
    if (events.length > 0) {
      return {
        events,
        lockVersion
      };
    }
  }
  return { events: null, lockVersion: null };
}

export {
  lockEvents
};
